import { useAtom } from "jotai";

import { $collabRegistryEffect } from "../../internal/document-collab-registry";

/**
 * Hook that mounts the collab registry effect.
 *
 * Call this once at app startup to subscribe to collab sessions for all workspaces. The
 * subscriptions run forever and keep collab session data up-to-date.
 */
export function useCollabRegistryLoader() {
	useAtom($collabRegistryEffect);
}
